import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=5594d2c2&scoped=true"
import script from "./userGroup.vue?vue&type=script&lang=js"
export * from "./userGroup.vue?vue&type=script&lang=js"
import style0 from "./userGroup.vue?vue&type=style&index=0&id=5594d2c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594d2c2",
  null
  
)

export default component.exports